export default "__VITE_ASSET__CNbE8nW9__"